import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'Components/Atoms/Select/Select';

const getInvoiceTypes = (t) => [
    { value: null, label: t('tax-authority-config-all-option') },
    { value: 'R1', label: t('ticketbai-invoice-type-r1') },
    { value: 'R2', label: t('ticketbai-invoice-type-r2') },
    { value: 'R3', label: t('ticketbai-invoice-type-r3') },
    { value: 'R4', label: t('ticketbai-invoice-type-r4') },
    { value: 'R5', label: t('ticketbai-invoice-type-r5') },
];

const getIssuerTypeOptions = (t) => [
    { value: null, label: t('ticketbai-issuer-type-direct') },
    { value: 'T', label: t('ticketbai-issuer-type-third-party') },
    { value: 'D', label: t('ticketbai-issuer-type-self-invoice') },
];

const getRegimeOptions = (t) => [
    { value: null, label: t('tax-authority-config-all-option') },
    { value: '01', label: t('ticketbai-regime-01') },
    { value: '02', label: t('ticketbai-regime-02') },
    { value: '03', label: t('ticketbai-regime-03') },
    { value: '04', label: t('ticketbai-regime-04') },
    { value: '05', label: t('ticketbai-regime-05') },
    { value: '06', label: t('ticketbai-regime-06') },
    { value: '07', label: t('ticketbai-regime-07') },
    { value: '08', label: t('ticketbai-regime-08') },
    { value: '09', label: t('ticketbai-regime-09') },
    { value: '10', label: t('ticketbai-regime-10') },
    { value: '11', label: t('ticketbai-regime-11') },
    { value: '12', label: t('ticketbai-regime-12') },
    { value: '13', label: t('ticketbai-regime-13') },
    { value: '14', label: t('ticketbai-regime-14') },
    { value: '15', label: t('ticketbai-regime-15') },
    { value: '17', label: t('ticketbai-regime-17') },
    { value: '19', label: t('ticketbai-regime-19') },
    { value: '51', label: t('ticketbai-regime-51') },
    { value: '52', label: t('ticketbai-regime-52') },
    { value: '53', label: t('ticketbai-regime-53') },
    { value: '54', label: t('ticketbai-regime-54') },
];

export default function ContactEditorDrawerDefaultValuesFormTicketBAI(props) {
    const { values, onChangeValue } = props;

    const { t } = useTranslation('invoices');

    const invoiceTypes = getInvoiceTypes(t);
    const issuerTypeOptions = getIssuerTypeOptions(t);
    const regimeOptions = getRegimeOptions(t);

    return (
        <div className="grid gap-6 pt-5">
            <Select
                value={values.es_tbai_doc_type}
                onChange={(value) => onChangeValue({ es_tbai_doc_type: value })}
                label={t('ticketbai-invoice-type-label')}
                options={invoiceTypes}
                className="w-full"
            />

            <Select
                value={values.es_tbai_issuer_type}
                onChange={(value) => onChangeValue({ es_tbai_issuer_type: value })}
                label={t('ticketbai-issuer-type-label')}
                options={issuerTypeOptions}
                className="w-full"
            />

            <Select
                value={values.es_tbai_regime}
                onChange={(value) => onChangeValue({ es_tbai_regime: value })}
                label={t('ticketbai-regime-label')}
                options={regimeOptions}
                className="w-full"
            />
        </div>
    );
}

ContactEditorDrawerDefaultValuesFormTicketBAI.propTypes = {
    values: PropTypes.object.isRequired,
    onChangeValue: PropTypes.func.isRequired,
};
